import { styled, Tabs, Tab, Box, Button } from "@mui/material";

import starIcon from "../../assets/icons/icon_star.svg";

export const InteractiveButtonsRoot = styled(Box)(({ theme, show }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "stretch",
  alignItems: "stretch",
  position: "fixed",
  left: 0,
  top: "auto",
  width: "100%",
  height: "auto",
  maxHeight: "92dvh",
  transition: "all ease-in-out 0.5s",
  zIndex: 1,
  pointerEvents: "auto",
  boxSizing: "border-box",
  padding: 0,
  gap: 5,
  [theme.breakpoints.up("lg")]: {
    padding: "0 20px 20px",
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: 20,
  },
  "&:before": {
    pointerEvents: "none",
    content: '""',
    position: "absolute",
    width: "100%",
    height: "130%",
    background:
      "linear-gradient(0deg, rgba(40, 40, 35, 1) 60%, rgba(40, 40, 35, 0) 100%)",
    transition: "all linear 0.5s",
    left: 0,
    right: 0,
    top: "-30%",
    bottom: show ? "0" : "-100dvh",
    zIndex: -1,
    [theme.breakpoints.up("md")]: {
      bottom: show ? "0" : "-40dvh",
      background:
        "linear-gradient(0deg, rgba(40, 40, 35, 1) 10%, rgba(40, 40, 35, 0) 100%)",
    },
    [theme.breakpoints.up("lg")]: {
      bottom: show ? "0" : "-50dvh",
    },
  },
}));

export const ContentLeft = styled(Box)(({ theme }) => ({
  zIndex: 3,
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  overflowX: "hidden",
  width: "auto",
  flex: "0 0 77%",
  padding: 0,
  margin: 0,
  gap: 5,
  [theme.breakpoints.up("lg")]: {
    gap: 10,
  },
}));

export const ContentRight = styled(Box)(({ theme }) => ({
  zIndex: 3,
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  overflowX: "hidden",
  width: "auto",
  flex: "0 0 22%",
  padding: 0,
  margin: 0,
  borderRadius: theme?.borderRadius?.default,
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    background: theme?.palette?.companyColors?.neutral,
    opacity: theme?.palette?.companyColors?.opacity75,
  },
}));

export const LeftContent = styled(Box)(({ theme }) => ({
  zIndex: 3,
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  overflowX: "hidden",
  width: "100%",
  borderRadius: theme?.borderRadius?.default,
  maxHeight: "23rem",
  height: 190,
  [theme.breakpoints.up("md")]: {
    height: "fit-content",
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    background: theme.palette.companyColors.neutral,
    opacity: theme.palette.companyColors.opacity75,
  },
}));

export const Categories = styled(Tabs)(({ theme, show }) => ({
  zIndex: 99,
  position: "relative",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  overflowX: "hidden",
  width: "100%",
  minHeight: 35,
  transition: "all ease-in-out 0.5s",
  paddingRight: 10,
  borderRadius: show ? theme?.borderRadius?.default : "8px 8px 0 0",
  pointerEvents: "auto",
  "& .MuiTabs-scroller": {
    zIndex: 9999,
  },
  "& .MuiTabScrollButton-root": {
    zIndex: 9,
    svg: {
      fontSize: "2.75rem",
    },
  },
  "& .MuiTabs-scrollButtons.Mui-disabled": {
    display: "none", // hide inactive buttons
  },
  "& .MuiTabs-indicator": {
    zIndex: 9,
    backgroundColor: theme?.palette?.companyColors?.accent, // the moving underline
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 1,
    background: theme?.palette?.companyColors?.neutral,
    opacity: theme?.palette?.companyColors?.opacity75,
    pointerEvents: "none",
  },
}));

export const Category = styled(Tab)(
  ({ theme, active, divider, heightDivider }) => ({
    zIndex: 99999,
    minWidth: 70,
    width: "auto",
    padding: "1.25rem 3rem 1rem",
    minHeight: 35,
    transition: "all ease-in-out 0.3s",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "1.8rem",
    textTransform: "initial",
    textAlign: "left",
    opacity: 1,
    position: "relative",
    cursor: active ? "initial" : "pointer",
    "&.MuiTab-root": {
      color: theme?.palette?.companyColors?.secondary, // default text color
      textTransform: "none",
      fontWeight: 500,
    },
    "&.Mui-selected": {
      color: theme?.palette?.companyColors?.accent, // active text color
    },
    "&:before": {
      content: '""',
      display: divider ? "block" : "none",
      position: "absolute",
      right: 0,
      top: 0,
      bottom: 0,
      width: 1,
      margin: "auto",
      height: heightDivider,
      zIndex: -1,
      background: theme?.palette?.companyColors?.greyLight1,
    },
    "&:hover": {
      color: theme?.palette?.companyColors?.primary,
    },
  })
);

export const SubCategories = styled(Tabs)(({ theme }) => ({
  zIndex: 9,
  position: "relative",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  flexWrap: "no-wrap",
  alignItems: "center",
  minHeight: "auto",
  width: "100%",
  transition: "all ease-in-out 0.5s",
  "& .MuiTabScrollButton-root": {
    zIndex: 9,
    svg: {
      fontSize: "2.75rem",
    },
  },
  "& .MuiTabs-scrollButtons.Mui-disabled": {
    display: "none", // hide inactive buttons
  },
  "& .MuiTabs-indicator": {
    backgroundColor: theme?.palette?.companyColors?.accent, // the moving underline
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: -1,
    background: theme?.palette?.companyColors?.neutral,
    opacity: theme?.palette?.companyColors?.opacity50,
  },
}));

export const TabIcon = styled("img")(({ theme }) => ({
  width: 25,
  display: "block",
}));

export const OptionsBlock = styled(Box)(({ theme, divider }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  position: "relative",
  padding: 0,
  paddingRight: "1.75rem",
  [theme.breakpoints.up("md")]: {
    paddingRight: "2.5rem",
  },
  [theme.breakpoints.up("xl")]: {
    paddingRight: "1.5rem",
  },
  "&:before": {
    content: '""',
    display: divider ? "block" : "none",
    position: "absolute",
    right: 0,
    bottom: 5,
    width: 1,
    margin: "auto",
    height: "59%",
    zIndex: 5,
    background: theme?.palette?.companyColors?.greyLight1,
  },
}));

export const OptionsList = styled(Box)(({ theme, length }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  padding: 0,
}));

export const OptionButton = styled(Button)(({ theme, active, plainStyle }) => ({
  zIndex: 3,
  position: "relative",
  padding: 0,
  pointerEvents: active ? "none" : "initial",
  cursor: !active ? "pointer" : "initial",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: 55,
  minWidth: 55,
  height: 55,
  margin: "0 7px 0 0",
  [theme.breakpoints.up("lg")]: {
    width: 70,
    height: 70,
    margin: "0 5px 0 0",
  },
  "&::before": {
    content: '""',
    display: "block",
    width: 61,
    height: 61,
    position: "absolute",
    top: -3,
    left: -3,
    border: `1.5px solid ${theme?.palette?.companyColors?.secondary}`,
    borderRadius: theme?.borderRadius?.default,
    opacity: active ? 1 : 0,
    transition: "all 0.3s ease",
    [theme.breakpoints.up("lg")]: {
      width: 72,
      height: 72,
      top: -1,
      left: -1,
      borderWidth: 2.5,
    },
  },
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: !plainStyle ? "cover" : "fill",
    objectPosition: "center",
    zIndex: 0,
    transition: "all 0.3s ease",
    borderRadius: theme?.borderRadius?.small,
    boxShadow: plainStyle ? "none" : "0px 0px 5px rgba(0,0,0,0.25)",
    [theme.breakpoints.up("lg")]: {
      width: "89%",
      height: "89%",
    },
  },
  "&:hover": {
    "&::before": {
      opacity: theme?.palette?.companyColors?.opacity50,
    },
  },
}));

export const OptionRoundButton = styled(Box)(({ theme, active }) => ({
  zIndex: 3,
  position: "relative",
  padding: 0,
  pointerEvents: active ? "none" : "initial",
  cursor: !active ? "pointer" : "initial",
  minWidth: "10rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    minWidth: "8rem",
  },
  "&::before": {
    content: "''",
    position: "absolute",
    width: "1.5rem",
    height: "1.5rem",
    top: "-0.75rem",
    left: "calc(50% - 3rem)",
    opacity: active ? 1 : 0.5,
    filter: "brightness(0) invert(1)",
    display: active ? "block" : "none",
    backgroundImage: `url(${starIcon})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundPosition: "center",
    transition: "all 0.3s ease-out",
  },
  "& span": {
    fontSize: active ? "1.5rem" : "1.5rem",
    fontWeight: "300",
    textTransform: "initial",
    textAlign: "center",
    zIndex: 1,
    transition: "all 0.1s ease-out",
    position: "absolute",
    top: active ? "115%" : "110%",
    left: "50%",
    transform: "translateX(-50%)",
    width: "auto",
    whiteSpace: "nowrap",
  },
  ":hover": {
    "@media (hover: hover) and (pointer: fine)": {
      "& span": {
        fontSize: "1.5rem",
        top: "113%",
      },
      "&:before": {
        display: "block",
        opacity: !active && "0.5",
      },
    },
  },
}));

export const OptionRoundButtonImg = styled(Box)(({ theme, active }) => ({
  padding: 0,
  position: "relative",
  overflow: "hidden",
  boxSizing: "border-box",
  transition: "all 0.3s ease",
  zIndex: 0,
  width: "4rem",
  height: "4rem",
  borderRadius: "100%",
  // border: active ? "2px solid #fa0" : "2px solid transparent",
  border: active ? "2px solid #071A3D" : "2px solid transparent",
  "& img": {
    display: "block",
    position: "relative",
    width: "4rem",
    height: "4rem",
    objectFit: "cover",
    objectPosition: "center",
    margin: "auto",
    zIndex: 0,
    transition: "all 0.3s ease",
  },
  "&:hover": {
    "@media (hover: hover) and (pointer: fine)": {
      border: !active && "2px solid rgba(255, 170, 0, 1)",
    },
  },
}));

// -------------------------- Cinematic Buttons --------------------------

export const CinematicControls = styled(Box)(({ theme, show }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "1rem",
  position: "fixed",
  right: "auto",
  bottom: show ? 0 : "-15vh",
  top: "auto",
  left: "50%",
  transform: "translateX(-50%)",
  margin: "auto",
  zIndex: 9,
  transition: "all ease-in-out 0.5s",
  padding: "2vh 3vw 3vh",
  [theme.breakpoints.down("lg")]: {
    padding: "2vh 5vw 3vh",
  },
  [theme.breakpoints.down("md")]: {
    left: "13rem",
    transform: "none",
    bottom: "1.5rem",
    padding: 0,
    "@media (orientation: landscape)": {
      left: "auto",
      right: "24rem",
      bottom: "5vh",
    },
  },
  [theme.breakpoints.down("sm")]: {
    left: "auto",
    right: "1.8rem",
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    // background: "linear-gradient(0deg, rgba(255, 255, 255, 1) 60%, rgba(255, 255, 255, 0) 95%)",
    transition: "all linear 0.5s",
    bottom: show ? 0 : "-10vh",
    left: 0,
    righ: 0,
    zIndex: -1,
    borderRadius: "4px 4px 0 0",
    [theme.breakpoints.up("md")]: {
      bottom: show ? 0 : "-15vh",
      background:
        "linear-gradient(0deg, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 115%)",
    },
  },
}));

export const CinematicButton = styled(Button)(({ theme, active }) => ({
  width: "3.6rem",
  height: "3.6rem",
  minWidth: 0,
  minHeight: 0,
  padding: 0,
  borderRadius: "4px",
  // background: "#fa0",
  // color: "#fff",
  background: "#071A3D",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  transition: "all ease-out 0.3s 0s",
  boxSizing: "border-box",
  "& img": {
    height: "1.6rem",
    width: "auto",
    // filter: "brightness(0) invert(0)",
    filter: "brightness(0) invert(1)",
  },
  ":hover": {
    "@media (hover: hover) and (pointer: fine)": {
      // background: "rgba(255,170,0, 0.3)",
      background: "rgba(7,26,61, 0.75)",
    },
    "@media (hover: none)": {
      // background: "rgba(255,170,0, 0.3)",
      background: "rgba(7,26,61, 0.75)",
    },
  },
}));

export const ToggleMenuBtn = styled(Box)(({ theme, show }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: -25,
  margin: "auto",
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  width: 40,
  height: 25,
  zIndex: 30,
  color: "#282823",
  background: "rgba(255,255,255, 0.75)",
  borderRadius: "20px 20px 0 0",
  boxShadow: "none",
  transition: "all 0.25s ease",
  "& svg": {
    marginTop: 2.5,
    transform: !show ? "rotate(-180deg)" : "none",
    transition: "all 0.5s ease",
    "& path": {
      stroke: "#282823",
    },
  },
  "&:hover": {
    background: "rgba(255,255,255, 1)",
  },
  [theme.breakpoints.up("lg")]: {
    width: 50,
    height: 30,
    borderRadius: "25px 25px 0 0",
    top: -30,
  },
}));

export const Divider = styled(Box)(({ theme, height }) => ({
  height: height ? height : "100%",
  position: "relative",
  width: "1px",
  display: "block",
  zIndex: 99,
  background: theme?.palette?.companyColors?.greyLight1,
}));
